"use client";

export const Home = () => {
  return (
    <div className="h-screen flex items-center justify-center bg-linear-to-br from-zinc-900 to-black flex-col">
      <p className="text-2xl font-medium text-white ">The Pollinator 3000</p>

      <button
        onClick={() => (window.location.href = "/poll")}
        className="w-[40%] bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-700 
                       active:scale-[0.98] text-white font-medium py-2.5 
                       rounded-lg shadow-lg transition cursor-pointer mt-5">
        Create a poll!
      </button>
    </div>
  );
};
